
export default {
    name: 'DeleteAccountConfirm',
    props: {
        value: { type: Boolean, default: false } // v-model：是否顯示
    },
    data() {
        return {
            step: 1,
            countdown: 0,
            timer: null,
            confirmText: ''
        }
    },
    computed: {
        confirmed() {
            return this.confirmText.trim().toLowerCase() === this.$t('auth_43').toLowerCase()
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(visible) {
                this.clearTimer()
                if (!visible) return
                // 每次開啟都從第一步重新倒數
                this.step = 1
                this.confirmText = ''
                this.countdown = 5
                this.timer = setInterval(() => {
                    if (--this.countdown <= 0) this.clearTimer()
                }, 1000)
            }
        }
    },
    beforeDestroy() {
        this.clearTimer()
    },
    methods: {
        clearTimer() {
            clearInterval(this.timer)
            this.timer = null
        }
    }
}
